import React, { useState } from "react";
import "./inputComponent.css";
import EyeOpen from "../../assets/images/icons/password-hide.svg";
import EyeClose from "../../assets/images/icons/password-show.svg";

const InputComponent = ({
  placeholder,
  onChange,
  type,
  value,
  disabled,
  handleBlur,
}) => {
  const [passwordType, setPasswordType] = useState(type);

  const toggleEyeIcon = () => {
    if (passwordType === "password") {
      setPasswordType("text");
    } else {
      setPasswordType("password");
    }
  };

  return (
    <div className="input-component">
      <input
        className="input-box"
        placeholder={placeholder}
        onChange={onChange}
        type={passwordType}
        onBlur={handleBlur}
        value={value}
        onKeyDown={
          type == "password"
            ? (event) => {
                if (event.key === " ") {
                  event.preventDefault(); // Prevent space from being entered
                }
              }
            : undefined
        }
        disabled={disabled}
      />
      {type === "password" && (
        <span className="eye-icon" onClick={toggleEyeIcon}>
          {passwordType === "password" ? (
            <img src={EyeClose} alt="Eye-close" />
          ) : (
            <img src={EyeOpen} alt="Eye-open" />
          )}
        </span>
      )}
    </div>
  );
};

export default InputComponent;
